import React from "react";
import { useLang } from "../i18n/LanguageContext";

const LANGS = ["lt", "en", "ru"];

export const LanguageSwitcher = ({ dark = true }) => {
  const { lang, setLanguage } = useLang();
  const base = "text-xs uppercase tracking-widest font-sans px-1.5 py-1 transition-colors duration-300";
  const activeCls = "text-gold";
  const inactiveCls = dark ? "text-cream/40 hover:text-cream" : "text-charcoal/40 hover:text-charcoal";
  return (
    <div className="flex items-center gap-0.5" data-testid="language-switcher">
      {LANGS.map((l, i) => (
        <React.Fragment key={l}>
          {i > 0 && <span className={dark ? "text-cream/20" : "text-charcoal/20"}>/</span>}
          <button
            data-testid={`lang-${l}`}
            onClick={() => setLanguage(l)}
            className={`${base} ${lang === l ? activeCls : inactiveCls}`}
          >
            {l.toUpperCase()}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};
